module.exports = __webpack_public_path__ + "img/Symbinet.059d0089.png";